import { TextField } from '@mui/material';
import React from 'react';
import { Control, useController } from 'react-hook-form';

export interface TitleFieldProps {
  control: Control<any>;
  name: string;
}

const TitleField = ({ control, name }: TitleFieldProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name,
    rules: {
      required: 'Please provide a title',
      validate: { whitespace: value => !!value.trim() || 'Please provide a title that is not only whitespace' },
    },
  });

  return (
    <TextField
      {...field}
      error={!!error}
      helperText={error?.message}
      inputProps={{ maxLength: 100 }}
      label="Title"
      placeholder="Title"
      required
      id="cy-title"
    />
  );
};

export default TitleField;
